import { DialogActions } from "@mui/material";
import { styled } from "@mui/system";

export const ModalFooter = styled(DialogActions)(({ theme }) => ({
    backgroundColor: theme.colors.primaryBackground,
    padding: "12px 24px 16px 24px",
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
}));